// Sprint 11 A2: Overnight Events timeline

interface OvernightEvent {
  type: string;
  title: string;
  description: string;
  timestamp: string;
  revenueImpactCents: number;
}

const TYPE_ICONS: Record<string, string> = {
  new_lead: "🆕", deal_won: "🎉", deal_lost: "😞", review: "⭐",
  booking: "📅", campaign_result: "📊",
};

export function BriefingOvernightEvents({ events }: { events: OvernightEvent[] }) {
  if (events.length === 0) {
    return (
      <div className="text-xs text-[var(--color-muted-foreground)] text-center py-4 border border-dashed border-[var(--color-border)] rounded-lg">
        No overnight events
      </div>
    );
  }

  return (
    <div>
      <h2 className="text-sm font-bold text-[var(--color-muted-foreground)] uppercase tracking-wide mb-3">While You Were Away</h2>
      <div className="space-y-2">
        {events.map((e, i) => (
          <div key={i} className="flex items-start gap-2 text-xs">
            <span>{TYPE_ICONS[e.type] ?? "📌"}</span>
            <div className="flex-1">
              <span className="font-medium text-[var(--color-foreground)]">{e.title}</span>
              <span className="text-[var(--color-muted-foreground)] ml-1">{e.description}</span>
            </div>
            <span className="text-[10px] text-[var(--color-muted-foreground)] flex-shrink-0">
              {new Date(e.timestamp).toLocaleTimeString("en-US", { hour: "2-digit", minute: "2-digit" })}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}
